// src/pages/GestionCajasFisicas.jsx
import React, { useState, useEffect } from "react";
import api from "../services/api";
import Swal from "sweetalert2";

const GestionCajasFisicas = () => {
  const [cajas, setCajas] = useState([]);
  const [loading, setLoading] = useState(true);
  const [mostrarInactivas, setMostrarInactivas] = useState(false);

  useEffect(() => {
    cargarCajas();
  }, [mostrarInactivas]);

  const cargarCajas = async () => {
    try {
      setLoading(true);
      const res = await api.get("/cajas-fisicas", {
        params: { incluir_inactivas: mostrarInactivas }
      });
      setCajas(res.data);
    } catch (error) {
      console.error("Error al cargar cajas:", error);
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "No se pudieron cargar las cajas físicas",
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCrearCaja = async () => {
    const { value: formValues } = await Swal.fire({
      title: "🏪 Nueva Caja Física",
      html: `
        <div style="text-align: left;">
          <label style="display: block; margin-bottom: 5px; font-weight: 600;">Número/Nombre de Caja: *</label>
          <input id="numero" type="text" class="swal2-input" placeholder="Ej: Caja 4" style="width: 90%;">
          
          <label style="display: block; margin-top: 15px; margin-bottom: 5px; font-weight: 600;">Nombre Descriptivo:</label>
          <input id="nombre" type="text" class="swal2-input" placeholder="Ej: Caja Express" style="width: 90%;">
          
          <label style="display: block; margin-top: 15px; margin-bottom: 5px; font-weight: 600;">Ubicación:</label>
          <input id="ubicacion" type="text" class="swal2-input" placeholder="Ej: Planta baja" style="width: 90%;">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Crear",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#10b981",
      preConfirm: () => {
        const numero = document.getElementById("numero").value;
        const nombre = document.getElementById("nombre").value;
        const ubicacion = document.getElementById("ubicacion").value;

        if (!numero) {
          Swal.showValidationMessage("El número de caja es requerido");
          return false;
        }

        return { numero, nombre, ubicacion };
      },
    });

    if (formValues) {
      try {
        await api.post("/cajas-fisicas", formValues);
        Swal.fire({
          icon: "success",
          title: "¡Caja Creada!",
          text: `${formValues.numero} fue creada exitosamente`,
          confirmButtonColor: "#10b981",
        });
        cargarCajas();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.error || "No se pudo crear la caja",
        });
      }
    }
  };

  const handleEditarCaja = async (caja) => {
    const { value: formValues } = await Swal.fire({
      title: `✏️ Editar ${caja.numero}`,
      html: `
        <div style="text-align: left;">
          <label style="display: block; margin-bottom: 5px; font-weight: 600;">Número/Nombre de Caja: *</label>
          <input id="numero" type="text" class="swal2-input" value="${caja.numero}" style="width: 90%;">
          
          <label style="display: block; margin-top: 15px; margin-bottom: 5px; font-weight: 600;">Nombre Descriptivo:</label>
          <input id="nombre" type="text" class="swal2-input" value="${caja.nombre || ""}" style="width: 90%;">
          
          <label style="display: block; margin-top: 15px; margin-bottom: 5px; font-weight: 600;">Ubicación:</label>
          <input id="ubicacion" type="text" class="swal2-input" value="${caja.ubicacion || ""}" style="width: 90%;">
        </div>
      `,
      showCancelButton: true,
      confirmButtonText: "Guardar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#667eea",
      preConfirm: () => {
        const numero = document.getElementById("numero").value;
        const nombre = document.getElementById("nombre").value;
        const ubicacion = document.getElementById("ubicacion").value;

        if (!numero) {
          Swal.showValidationMessage("El número de caja es requerido");
          return false;
        }

        return { numero, nombre, ubicacion };
      },
    });

    if (formValues) {
      try {
        await api.put(`/cajas-fisicas/${caja.id}`, formValues);
        Swal.fire({
          icon: "success",
          title: "¡Caja Actualizada!",
          confirmButtonColor: "#10b981",
        });
        cargarCajas();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.error || "No se pudo actualizar la caja",
        });
      }
    }
  };

  const handleCambiarEstado = async (caja) => {
    const nuevoEstado = caja.estado === "activa" ? "inactiva" : "activa";
    const accion = nuevoEstado === "activa" ? "activar" : "desactivar";

    const result = await Swal.fire({
      title: `¿${accion.charAt(0).toUpperCase() + accion.slice(1)} ${caja.numero}?`,
      text: `Esta caja será ${nuevoEstado === "activa" ? "activada" : "desactivada"}`,
      icon: "question",
      showCancelButton: true,
      confirmButtonText: `Sí, ${accion}`,
      cancelButtonText: "Cancelar",
      confirmButtonColor: nuevoEstado === "activa" ? "#10b981" : "#ef4444",
    });

    if (result.isConfirmed) {
      try {
        await api.put(`/cajas-fisicas/${caja.id}`, { estado: nuevoEstado });
        Swal.fire({
          icon: "success",
          title: `¡Caja ${nuevoEstado === "activa" ? "Activada" : "Desactivada"}!`,
          confirmButtonColor: "#10b981",
        });
        cargarCajas();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.error || `No se pudo ${accion} la caja`,
        });
      }
    }
  };

  const handleEliminar = async (caja) => {
    const result = await Swal.fire({
      title: `¿Eliminar ${caja.numero}?`,
      text: "Si tiene turnos registrados, solo se desactivará",
      icon: "warning",
      showCancelButton: true,
      confirmButtonText: "Sí, eliminar",
      cancelButtonText: "Cancelar",
      confirmButtonColor: "#ef4444",
    });

    if (result.isConfirmed) {
      try {
        await api.delete(`/cajas-fisicas/${caja.id}`);
        Swal.fire({
          icon: "success",
          title: "¡Eliminada!",
          text: "La caja fue eliminada correctamente",
          confirmButtonColor: "#10b981",
        });
        cargarCajas();
      } catch (error) {
        Swal.fire({
          icon: "error",
          title: "Error",
          text: error.response?.data?.error || "No se pudo eliminar la caja",
        });
      }
    }
  };

  if (loading) {
    return (
      <div style={styles.loading}>
        <div style={styles.loadingText}>Cargando cajas físicas...</div>
      </div>
    );
  }

  return (
    <div style={styles.container}>
      {/* Header */}
      <div style={styles.header}>
        <div>
          <h1 style={styles.title}>🏪 Gestión de Cajas Físicas</h1>
          <p style={styles.subtitle}>Administración de cajas del negocio</p>
        </div>
        <button onClick={handleCrearCaja} style={styles.btnCrear}>
          ➕ Nueva Caja
        </button>
      </div>

      {/* Filtro */}
      <div style={styles.filtroCard}>
        <label style={styles.checkboxLabel}>
          <input
            type="checkbox"
            checked={mostrarInactivas}
            onChange={(e) => setMostrarInactivas(e.target.checked)}
            style={styles.checkbox}
          />
          Mostrar cajas inactivas
        </label>
      </div>

      {/* Lista de Cajas */}
      <div style={styles.cajasGrid}>
        {cajas.map((caja) => (
          <div
            key={caja.id}
            style={{
              ...styles.cajaCard,
              ...(caja.estado === "inactiva" ? styles.cajaInactiva : {}),
            }}
          >
            {/* Estado Badge */}
            <div style={styles.badges}>
              <span
                style={{
                  ...styles.badge,
                  ...(caja.estado === "activa"
                    ? styles.badgeActiva
                    : styles.badgeInactiva),
                }}
              >
                {caja.estado === "activa" ? "✅ Activa" : "⭕ Inactiva"}
              </span>
              {caja.disponibilidad === "ocupada" && (
                <span style={{ ...styles.badge, ...styles.badgeOcupada }}>
                  🔴 Ocupada
                </span>
              )}
              {caja.disponibilidad === "disponible" && caja.estado === "activa" && (
                <span style={{ ...styles.badge, ...styles.badgeDisponible }}>
                  🟢 Disponible
                </span>
              )}
            </div>

            {/* Info */}
            <div style={styles.cajaInfo}>
              <h3 style={styles.cajaNumero}>{caja.numero}</h3>
              {caja.nombre && (
                <p style={styles.cajaNombre}>{caja.nombre}</p>
              )}
              {caja.ubicacion && (
                <p style={styles.cajaUbicacion}>📍 {caja.ubicacion}</p>
              )}
            </div>

            {/* Acciones */}
            <div style={styles.cajaAcciones}>
              <button
                onClick={() => handleEditarCaja(caja)}
                style={styles.btnEditar}
                title="Editar"
              >
                ✏️
              </button>
              <button
                onClick={() => handleCambiarEstado(caja)}
                style={{
                  ...styles.btnEstado,
                  ...(caja.estado === "activa"
                    ? styles.btnDesactivar
                    : styles.btnActivar),
                }}
                title={caja.estado === "activa" ? "Desactivar" : "Activar"}
              >
                {caja.estado === "activa" ? "🔒" : "🔓"}
              </button>
              <button
                onClick={() => handleEliminar(caja)}
                style={styles.btnEliminar}
                title="Eliminar"
              >
                🗑️
              </button>
            </div>
          </div>
        ))}
      </div>

      {cajas.length === 0 && (
        <div style={styles.empty}>
          <div style={styles.emptyIcon}>🏪</div>
          <div style={styles.emptyText}>No hay cajas físicas</div>
          <button onClick={handleCrearCaja} style={styles.btnCrearEmpty}>
            ➕ Crear Primera Caja
          </button>
        </div>
      )}
    </div>
  );
};

const styles = {
  container: {
    minHeight: "100vh",
    background: "#f8fafc",
    padding: "20px",
    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
  },
  header: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    marginBottom: "20px",
    flexWrap: "wrap",
    gap: "15px",
  },
  title: {
    fontSize: "28px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0",
  },
  subtitle: {
    fontSize: "14px",
    color: "#64748b",
    margin: "5px 0 0 0",
  },
  btnCrear: {
    padding: "12px 24px",
    background: "#10b981",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  filtroCard: {
    background: "white",
    borderRadius: "12px",
    padding: "15px 20px",
    marginBottom: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  },
  checkboxLabel: {
    display: "flex",
    alignItems: "center",
    gap: "8px",
    fontSize: "14px",
    fontWeight: "500",
    color: "#475569",
    cursor: "pointer",
  },
  checkbox: {
    width: "18px",
    height: "18px",
    cursor: "pointer",
  },
  cajasGrid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fill, minmax(300px, 1fr))",
    gap: "20px",
  },
  cajaCard: {
    background: "white",
    borderRadius: "12px",
    padding: "20px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    transition: "all 0.2s",
    border: "2px solid transparent",
  },
  cajaInactiva: {
    opacity: "0.6",
    background: "#f8fafc",
  },
  badges: {
    display: "flex",
    gap: "8px",
    marginBottom: "15px",
    flexWrap: "wrap",
  },
  badge: {
    padding: "4px 12px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
  },
  badgeActiva: {
    background: "#d1fae5",
    color: "#059669",
  },
  badgeInactiva: {
    background: "#f1f5f9",
    color: "#64748b",
  },
  badgeOcupada: {
    background: "#fee2e2",
    color: "#dc2626",
  },
  badgeDisponible: {
    background: "#dcfce7",
    color: "#16a34a",
  },
  cajaInfo: {
    marginBottom: "15px",
  },
  cajaNumero: {
    fontSize: "22px",
    fontWeight: "700",
    color: "#1e293b",
    margin: "0 0 8px 0",
  },
  cajaNombre: {
    fontSize: "14px",
    color: "#64748b",
    margin: "0 0 5px 0",
  },
  cajaUbicacion: {
    fontSize: "13px",
    color: "#94a3b8",
    margin: "0",
  },
  cajaAcciones: {
    display: "flex",
    gap: "8px",
  },
  btnEditar: {
    flex: 1,
    padding: "10px",
    background: "#667eea",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "18px",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  btnEstado: {
    flex: 1,
    padding: "10px",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "18px",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  btnDesactivar: {
    background: "#f59e0b",
  },
  btnActivar: {
    background: "#10b981",
  },
  btnEliminar: {
    flex: 1,
    padding: "10px",
    background: "#ef4444",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "18px",
    cursor: "pointer",
    transition: "all 0.2s",
  },
  loading: {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
  },
  loadingText: {
    fontSize: "18px",
    color: "#64748b",
  },
  empty: {
    textAlign: "center",
    padding: "60px 20px",
    background: "white",
    borderRadius: "12px",
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
  },
  emptyIcon: {
    fontSize: "64px",
    marginBottom: "15px",
  },
  emptyText: {
    fontSize: "18px",
    color: "#64748b",
    marginBottom: "20px",
  },
  btnCrearEmpty: {
    padding: "12px 24px",
    background: "#10b981",
    color: "white",
    border: "none",
    borderRadius: "8px",
    fontSize: "15px",
    fontWeight: "600",
    cursor: "pointer",
  },
};

export default GestionCajasFisicas;